import { combineReducers, createFeature } from '@ngrx/store';
import { authApiFeature, AuthApiFeatureState } from './auth-api.reducer';
import { authBusinessProfilesApiFeature, AuthBusinessProfilesApiState } from './auth-business-profiles-api.reducer';
import { authBusinessProfilesPageFeature, AuthBusinessProfilesPageState } from './auth-business-profiles-page.reducer';
import { authPageFeature, AuthPageState } from './auth-page.reducer';

export interface AuthState {
  [authApiFeature.name]: AuthApiFeatureState;
  [authPageFeature.name]: AuthPageState;
  [authBusinessProfilesApiFeature.name]: AuthBusinessProfilesApiState;
  [authBusinessProfilesPageFeature.name]: AuthBusinessProfilesPageState;
}

export const authFeatures = createFeature<string, AuthState>({
  name: 'auth',
  reducer: combineReducers<AuthState>({
    [authApiFeature.name]: authApiFeature.reducer,
    [authPageFeature.name]: authPageFeature.reducer,
    [authBusinessProfilesApiFeature.name]: authBusinessProfilesApiFeature.reducer,
    [authBusinessProfilesPageFeature.name]: authBusinessProfilesPageFeature.reducer
  })
});
